import * as XLSX from 'xlsx'

/**
 * True when the uploaded sheet's header is a single "barcode" column. Add /
 * Update sheets need product columns (price, quantity, …), and the backend's
 * bulk endpoints reject a barcode-only sheet outright. We catch that
 * client-side so the supplier gets a clear message instead of a generic
 * server error.
 *
 * Returns false on any parse problem — we only block when we positively
 * detect the barcode-only shape; the server still validates everything else.
 */
export async function isBarcodeOnlySheet(file: File): Promise<boolean> {
  try {
    const buf = await file.arrayBuffer()
    const wb = XLSX.read(buf, {type: 'array'})
    const sheet = wb.Sheets[wb.SheetNames[0]]
    if (!sheet) return false
    const rows = XLSX.utils.sheet_to_json<unknown[]>(sheet, {header: 1}) as unknown[][]
    if (!rows.length) return false
    const header = (rows[0] as unknown[])
      .map((h) => String(h ?? '').trim())
      .filter((h) => h !== '')
    return header.length === 1 && ['barcode', 'barcodes'].includes(header[0].toLowerCase())
  } catch {
    return false
  }
}
